import {Component} from '@angular/core';

@Component({
  selector: 'iaud-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {}
